import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Button,
  Space,
  message,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import "../Edit.scss";
import { CustomTable } from "@/hocComponents";
import LinkPaymentTable from "./linkPaymentTable.js";
import commonFn from "@/utils/commonFn";

const TradeLinkPaidPayments = forwardRef(({contractId, projectId, vendorId, propId, submitInitFn,}, ref) => {
    const [tableType, setTableType] = useState(false);
    const [modalName, setModalName] = useState('Link Paid Payments');
    const [selectedRow, setSelectedRow] = useState([]);
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    
    useImperativeHandle(ref, () => ({
      openModal: (_, modalName) => {
        setModalFlag(true)
        setTableType(modalName === 'Link Paid Payments')
        setModalName(modalName)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        initColunmsFn()
        getLinkPaymentFn()
        getTableListFn(1, tableType ? 25 : 100)
      }else{
        setTableList([])
        setTableLoading(false)
        setTableHead(initTableHead)
        setPagination({
          current: 1,
          pageSize: 25,
          total: 0,
        })
        setSelectedRow([])
        setRefreshKey(+new Date())
        setBtnLoading(false)
        setBtnDisabled(false)
        // 
        setTableList2([])
        setTableLoading2(false)
      }
    }

    const initTableHead = {
      remark: undefined,
      checkNo: undefined,
      amount: undefined,
      batch:undefined,
    }

    const [tableHead, setTableHead] = useState(initTableHead);

    const tableFilterFn = (event, key, type = 'Input') => {
      commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: tableType ? 25 : 100})
    }

    const initColumns = [
      {
        title: 'Check Date',
        dataIndex: "checkDate",
        titleType: '',
        isSorter: false,
        format: 'MM/DD/YYYY',
        render: ((text) => (text && moment(text).format("MM/DD/YYYY")) || "")
      },
      {
        title: "Check #",
        dataIndex: "checkNo",
        titleType: "",
        width: 110,
        isSorter: true,
        sortterMultiple: 2,
        onChange: (e) => tableFilterFn(e, 'checkNo'),
      },
      {
        title: "Amount",
        dataIndex: "amount",
        titleType: "Input",
        width: 100,
        isSorter: true,
        isAmountFlag: true,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, 'amount'),
      },
      {
        title: 'Vendor Name',
        dataIndex: "vendorName",
        titleType: 'Input',
        width: 100,
        isSorter: true,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, 'vendorName'),
      },
      {
        title: "GL_Title",
        dataIndex: "glTitle",
        titleType: "Input",
        width: 100,
        isSorter: true,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, 'glAcct'),
      },
      {
        title: "Remark",
        dataIndex: "remark",
        titleType: "Input",
        width: 100,
        isSorter: true,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, 'remark'),
      },
      {
        title: "Batch",
        dataIndex: "batch",
        titleType: "Input",
        width: 100,
        isSorter: true,
        sortterMultiple: 3,
        onChange: (e) => tableFilterFn(e, 'batch'),
      },
      // {
      //   title: "User Name",
      //   dataIndex: "userName",
      //   titleType: "Input",
      //   width: 100,
      //   isSorter: true,
      //   sortterMultiple: 3,
      //   onChange: (e) => tableFilterFn(e, 'userName'),
      // },
      {
        title: 'Last Updated Date',
        dataIndex: "udate",
        titleType: '',
        isSorter: false,
        format: 'MM/DD/YYYY',
        render: ((text) => (text && moment(text).format("MM/DD/YYYY")) || "")
      },
    ];

    const [columns, setColumns] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [tableList, setTableList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 25,
      total: 0,
    });

    const [tableList2, setTableList2] = useState([]);
    const [tableLoading2, setTableLoading2] = useState(false);
    const getLinkPaymentFn = async() => {
      setTableLoading2(true);
      const response = await http.post(api.getLinkPayment, { contractId, recordType: tableType ? 1 : 2});
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response)
        setTableLoading2(false);
        return
      }
      const list = (response.data || []).map((item, index) => ({ ...item, '#': index + 1}));
      setTableList2(list);
      setSelectedRow(list);
      setTableLoading2(false);
    }

    // 获取列表数据
    const getTableListFn = async (current, pageSize, tableHead = {}) => {
      setTableLoading(true);
      let params = {
          page: current || pagination.current,
          count: pageSize || pagination.pageSize,
          contractId,
          projectId,
          propId,
          vendorId,
          ...tableHead
      };
      const response = await http.post(tableType ? api.getContractVendorPaymentList : api.getOtherContractVendorPaymentList, {
        ...params,
      });
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response)
        setTableLoading(false);
        return
      }
      const { page } = response.data
      const list = (page.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
      setTableList(list);
      setPagination((prev) => ({
          ...prev,
          total: page.total || 0,
          current: params.page,
          pageSize: params.count,
      }));
      setTableLoading(false);
    };

    const submitFn = async() => {
      const tableList2IdList = tableList2.map(item => item.vendorPaymentId);
      const selectedRowIdList = selectedRow.map(item => item.vendorPaymentId);
      const vendorPaymentIds = selectedRow.filter(item => !tableList2IdList.includes(item.vendorPaymentId))?.map(k => k.vendorPaymentId) || []
      const delIds = tableList2.filter(item => !selectedRowIdList.includes(item.vendorPaymentId))?.map(k => k.recordId) || []
      if(!vendorPaymentIds?.length && !delIds?.length){
        message.warning("Please select at least one item.");
        return
      }
      setBtnLoading(true)
      const response = await http.post(tableType ? api.sysDelPaymentToRecordBatch : api.sysOtherDelPaymentToRecordBatch, {
        projectId,
        contractId,
        recordType: tableType ? 1 : 2,
        vendorPaymentIds,
        delIds
      });
      if (response.code === "1") {
        message.success('Submit successfully');
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }


    const initColunmsFn = () => {
      setTableHead(initTableHead);
      setColumns(initColumns);
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          { modalName }
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="95%"
    >
      <div style={{display: 'flex', }}>
        <div style={{display: 'flex', flexDirection: 'column', flex: 6}}>
          <CustomTable 
            refreshKey={refreshKey}
            tableLoading={tableLoading}
            rowKey="vendorPaymentId"
            rowSelection={{
              type: "checkbox",
              preserveSelectedRowKeys: true,
              selectedRowKeys: selectedRow?.filter(item => item?.vendorPaymentId)?.map(item => item.vendorPaymentId),
              getCheckboxProps: (record) => ({
                disabled: record?.isChecked
              }),
              onChange: (keys, rows) => {
                setSelectedRow(pre => {
                  const tableList2IdList = tableList2.map(item => item.vendorPaymentId)
                  const selectedMap = new Map(pre.map(item => [item['vendorPaymentId'], item]));
                  // 1. 移除被取消勾选的项
                  [...selectedMap.keys()].forEach(k => {
                    if (!keys.includes(k)) selectedMap.delete(k);
                  });
                  // 2. 添加当前页新勾选的数据
                  rows.filter(Boolean).forEach(item => {
                    selectedMap.set(item['vendorPaymentId'], item);
                  });
                  const list = Array.from(selectedMap.values())
                  const result = list.map(item => {
                      return {
                        ...item,
                        rowColorFlag: !tableList2IdList.includes(item.vendorPaymentId)
                      }
                  })
                  return result;
                })
              },
            }}
            rowClassName={(record) => {
              if(record?.isChecked){
                return ["grey-row"]
              }
            }}
            columns={columns}
            tableList={tableList}
            pagination={pagination}
            setTableHead={setTableHead}
            getTableListFn={getTableListFn}
            tableScrollY="350px"
            tableCss="TradeLinkPaidPayments"
          />
          <div style={{textAlign:'center', marginTop: 24}}>
            <Space align="center">
              <Button key="back" onClick={() => setModalFlag(false)}>
                Cancel
              </Button>
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            </Space>
          </div>
        </div>
        {!tableType && <div style={{flex: 4, marginLeft: 30}}>
          <LinkPaymentTable
            tableList={selectedRow}
            tableLoading={tableLoading2}
          />
        </div> || null}
      </div>
    </Modal>
    
  );
});

export default TradeLinkPaidPayments;